import { LogoWord } from "@/components/Logo";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-[#1A3C2A] text-[#FAF7F2]/80 mt-16 md:mb-0 mb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <LogoWord light />
          <p className="text-sm mt-3 max-w-xs">Your neighbourhood marketplace. Buy local. Sell local. Support people in your community.</p>
        </div>
        <div>
          <p className="font-display font-bold text-white mb-3">Shop</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/browse" className="hover:text-[#E07A5F]">Browse products</Link></li>
            <li><Link to="/browse" className="hover:text-[#E07A5F]">Categories</Link></li>
            <li><Link to="/favourites" className="hover:text-[#E07A5F]">Favourites</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-display font-bold text-white mb-3">Sell</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/sell" className="hover:text-[#E07A5F]">Sell on Nabor</Link></li>
            <li><Link to="/sell" className="hover:text-[#E07A5F]">Start a shop</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-display font-bold text-white mb-3">Account</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/account" className="hover:text-[#E07A5F]">My account</Link></li>
            <li><Link to="/orders" className="hover:text-[#E07A5F]">My orders</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-[#FAF7F2]/50">© 2026 Nabor. Made for local communities.</div>
    </footer>
  );
}
